import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import isObject from 'lodash.isobject'
import { advertisements } from '../../initial_state'
import {
  DEFAULT_REL,
  GAB_AD_PLACEMENTS,
} from '../../constants'
import { getRandomInt } from '../../utils/numbers'
import {
  saveAdvertisementClickData,
  saveAdvertisementViewData,
  incrementViewCountForAdvertisement,
} from '../../actions/advertisements'
import Button from '../button'

class GabAdBase extends React.Component {

  state = {
    ad: null,
  }

  componentDidMount() {
    this.setState({
      ad: this._getRandomAdvertisement(),
    })
  }

  componentWillUnmount() {
    const { ad } = this.state
    if (!isObject(ad)) return

    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    this.props.onSaveAdvertisementViewData(ad.id)
  }

  _getRandomAdvertisement() {
    if (!Array.isArray(advertisements)) return null

    const { placement } = this.props

    // get array of ads by placement
    const adsByPlacement = advertisements.filter((ad) => ad.placement === placement)
    const index = getRandomInt(0, adsByPlacement.length - 1)

    return adsByPlacement[index]
  }

  handleOnClick = () => {
    const { ad } = this.state
    const { placement } = this.props
    if (!isObject(ad)) return null

    this.props.onSaveAdvertisementClickData(ad.id, placement)
  }

  handleOnView = () => {
    const { ad } = this.state
    if (!isObject(ad)) return null

    this.props.onIncrementViewCountForAdvertisement(ad.id)
  }

  setRef = (node) => {
    this.node = node

    // set up io
    if (!!window.IntersectionObserver) {
      this.observer = new IntersectionObserver((entries) => { 
        entries.forEach((entry) => {
          if (entry.isIntersecting){
            this.handleOnView()
          }
        });
      }, { threshold: 0.5 });

      this.observer.observe(this.node)
    }
  }

  render() {
    const { ad } = this.state
    const { children } = this.props

    // wait til load
    if (!ad) return null

    return (
      <Button
        noClasses
        buttonRef={this.setRef}
        className={[_s.d, _s.bgTransparent, _s.cursorPointer, _s.outlineNone, _s.w100PC, _s.hAuto, _s.noUnderline].join(' ')}
        href={ad.url}
        onClick={this.handleOnClick}
        target='_blank'
        rel={DEFAULT_REL}
      >
        {children(ad)}
      </Button>
    )
  }

}

const mapDispatchToProps = (dispatch) => ({
  onSaveAdvertisementClickData(adId, placement) {
    dispatch(saveAdvertisementClickData(adId, placement))
  },
  onSaveAdvertisementViewData(adId) {
    dispatch(saveAdvertisementViewData(adId))
  },
  onIncrementViewCountForAdvertisement(adId) {
    dispatch(incrementViewCountForAdvertisement(adId))
  },
})

GabAdBase.propTypes = {
  children: PropTypes.func.isRequired,
  placement: PropTypes.oneOf(Object.keys(GAB_AD_PLACEMENTS)),
  onSaveAdvertisementClickData: PropTypes.func.isRequired,
  onSaveAdvertisementViewData: PropTypes.func.isRequired,
  onIncrementViewCountForAdvertisement: PropTypes.func.isRequired,
}

export default connect(null, mapDispatchToProps)(GabAdBase)